/**
 * The hierarchy of components here is:
 * JobDrawer - thin wrapper to allow animated drawer transition without loading content
 * JobDrawerContent - queries for data, shows loading indicator
 * JobDrawerLoaded - UI the user interacts with
 */
import Drawer from '@material-ui/core/Drawer';
import {omit} from 'lodash';
import React, {useState} from 'react';

import {ResizableDrawer} from '../ResizableDrawer';
import * as S from './JobDrawer.styles';
import {JobDrawerContent, JobDrawerContentProps} from './JobDrawerContent';

export type JobDrawerProps = JobDrawerContentProps & {
  open: boolean;
};

// We instantiate the drawer even when there is no job id selected
// so that it can animate sliding in when one is selected.
export const JobDrawer = (props: JobDrawerProps) => {
  const {children, open, closeDrawer} = props;
  const [width, setWidth] = useState(500); // Remember last size
  const onSetWidth = (newWidth: number) => {
    setWidth(newWidth);
  };
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={closeDrawer}
      variant="persistent">
      <ResizableDrawer
        startWidth={width}
        minWidth={400}
        onSetWidth={onSetWidth}>
        <S.DrawerContents>
          <JobDrawerContent {...omit(props, ['children'])}>
            {children}
          </JobDrawerContent>
        </S.DrawerContents>
      </ResizableDrawer>
    </Drawer>
  );
};
